import { PatchDraft, PatchDraftToken } from "$src/application/projects/sub/drafts/commands/PatchDraft";
import { DraftNewPatch } from "$src/domain/projects/drafts/DraftNewPatch";
import { PatchResult } from "$src/domain/projects/drafts/PatchResult";
import { useMutation } from "@sveltestack/svelte-query";
import { Operation } from "fast-json-patch";
import { container } from "tsyringe";

export async function patchDraft(groupStoreId: number, projectId: number, operations: Operation[])
    : Promise<PatchResult> {

    const query = container.resolve<PatchDraft>(PatchDraftToken);
    return query.execute(groupStoreId, projectId, operations);
}

export function usePatchDraft() {
    return useMutation(
        ({ groupStoreId, projectId, operations }: 
            { groupStoreId: number, projectId: number, operations: Operation[] }
        ) => patchDraft(groupStoreId, projectId, operations)
    );
}